import type {AiChatProps} from '@AiChat/ai-chat.types';
import type {AiChatProviderOwnProps} from '@AiChat/providers/ai-chat-provider.types';

export async function fetchAiChatEmbedProps(): Promise<AiChatProps> {
  return (await window.PMW.readLocal('ai/chatEmbedProps')) as AiChatProps;
}

export function toAiChatProviderProps(props: AiChatProps): Omit<AiChatProviderOwnProps, 'isEmbedded' | 'presentation' | 'chatId'> {
  return {
    credits: props.credits,
    isPaygUserWithAiChatAccess: props.isPaygUserWithAiChatAccess,
    isReturningUser: props.isReturningUser,
    isSuperUser: props.isSuperUser,
    hasGeneratedAssets: props.hasGeneratedAssets,
    isMemoryEnabled: props.isMemoryEnabled,
    shouldShowAssetsIntroSubtitle: props.shouldShowAssetsIntroSubtitle,
    isAiChatCreateAVideoFeatureEnabled: props.isAiChatCreateAVideoFeatureEnabled,
    isTemplateRedesignFeatureEnabled: props.isTemplateRedesignFeatureEnabled,
    promptBoxPlaceholderKey: props.promptBoxPlaceholderKey,
    canUseEditableTextLayers: props.canUseEditableTextLayers,
    chargeForMakeTextEditable: props.chargeForMakeTextEditable,
    makeTextEditableLimit: props.makeTextEditableLimit,
    mode: props.mode,
  };
}
